<p>organisation-list works!</p>
<dspx-card-set-base-form [formServiceEndpoint]="formServiceEndpoint"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         [model]="model"
                         formName = "Organisation List"
                         (onFormLoad)="formLoad($event)"
                         (onDialogSubmit)="dialogButtonClicked($event)"
                         (onActionButtonClick)="actionButtonClicked($event)"
                         (onFilter)="filterData($event)">
</dspx-card-set-base-form>
